import { render } from "./terms-of-service.vue?vue&type=template&id=8b135dca&scoped=true"
import script from "./terms-of-service.vue?vue&type=script&lang=js"
export * from "./terms-of-service.vue?vue&type=script&lang=js"

import "./terms-of-service.vue?vue&type=style&index=0&id=8b135dca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b135dca"]])

export default __exports__